<!-- unit list -->
<ng-container *ngIf="hasUnitAutocomplete">
  <lhc-autocomplete 
    [options]="options" 
    [(dataModel)]="item.unit"
    (onBlurFn)="lhcDataService.activeRowOnBlur(item)"
    (onFocusFn)="lhcDataService.setActiveRow(item)"
    ></lhc-autocomplete>
</ng-container>

